// NOTE: RH - This mirrors the server-side equivalent.
// Values in here are not arbitrary and may influence logic in the backend.

export const WellKnownOrderCancellationReason = {
  EditingDocket: "Editing docket"
} as const;
